export default __webpack_public_path__ + "static/media/Mobile-Slide-2.478703a9.jpg";